import { deleteSingle, postSingle, putSingle } from '@/helper/apicalls';

import { baseURL } from './const';

export async function ptaAction({ request, params }: any) {
  const body = Object.fromEntries(await request.formData());

  if (body.userId) body.userId = JSON.parse(body.userId);

  const URL = baseURL + '/pta';
  // eslint-disable-next-line unicorn/prefer-ternary
  if (request.method == 'POST') {
    return postSingle(URL, body);
  } else if (request.method == 'PUT') {
    return putSingle(URL, params.id, body);
  } else if (request.method == 'DELETE') {
    return deleteSingle(URL, params.id);
  } else {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }
}
